// BaseUrl.js
// This file contains the base URL for the API calls.

const BASE_URL = "https://forumhubjavaservices.azurewebsites.net/api";
  //window.location.hostname === "localhost"
  //  ? "http://localhost:8080/api"
  //  : "https://forumhubjavaservices.azurewebsites.net/api";

export default BASE_URL;
